/**
 * @Description: 弹框方法
 */

/**
 * @export
 * @param {*} that  挂载了$alert方法的对象
 * @param {String} title  title 显示文字 默认显示失败
 */
export function elAlert(that,title){
  let obj = {
    customClass:'custom-message-box', //自定义添加Class
    confirmButtonText: 'Confirm',
    cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
    closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
    showClose:true,//去掉右上角的取消（X）
    center: true
  }
  return that.$alert(title,"",obj)
}

/**
 * @export
 * @param {*} that  挂载了$alert方法的对象
 * @param {String} title  title 显示文字 默认显示失败
 */
export function elConfirm(that,title,topTxt=""){
  let obj =  {
    customClass: "custom-message-box", //自定义添加Class
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
    closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
    center: true
  }
  return that.$confirm(title,topTxt,obj)
}


// WEBPACK FOOTER //
// ./src/utils/bulletBox.js